import type { IObservability } from './createObservability';

/** pagehide + beforeunload → flush fire-and-forget (não bloqueia unload). */
export function installLifecycleHandlers(obs: IObservability): () => void {
  const onLeave = () => {
    void obs.flush();
  };

  window.addEventListener('pagehide', onLeave);
  window.addEventListener('beforeunload', onLeave);

  return () => {
    window.removeEventListener('pagehide', onLeave);
    window.removeEventListener('beforeunload', onLeave);
  };
}
